import colors from 'vuetify/es5/util/colors';

export default {
  data() {
    return {
      colors: [
        colors.blueGrey.lighten5,
        colors.red.lighten1,
        colors.red.lighten3,
        colors.grey.base,
        colors.blue.lighten3,
        colors.blue.lighten1
      ]
    };
  },
  computed: {
    answers() {
      return [
        { value: 1, text: ['Very', 'Unlikely'], color: this.colors[1] },
        { value: 2, text: ['Somewhat', 'Unlikely'], color: this.colors[2] },
        { value: 3, text: ['Don\x27t', 'Know'], color: this.colors[3] },
        { value: 4, text: ['Somewhat', 'Likely'], color: this.colors[4] },
        { value: 5, text: ['Very', 'Likely'], color: this.colors[5] }
      ];
    }
  }
};
